export const TOGGLE_DB_LOADER = 'platform/fleet/loaders';
export const FLEET_FILES_COUNT = 'platform/fleet/files';
export const DB_LOADER = 'DB_LOADER';
export const FLEET_FILES_ACTIVITY_COUNT = 'platform/fleet/files/activity';
